import lodash from 'lodash'
import { useMemo } from 'react'

import type { IPickerGroup } from 'components/Editor/EditorElements/pickerConfig/elementsPicker.types'
import { filterElementsByBlockMode } from 'components/Editor/EditorElements/pickerConfig/elementsPickerFilter'
import { filterElems, sortedGroups } from 'components/Editor/Modals/ElementPickerModal/helpers'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getElement, getUsedElements } from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'

// TODO: need to refactor
export const useAvailableElements = (block?: Block | null, search?: string) => {
  const element = useProjectContext(getElement)

  const usedElements = useProjectContext(getUsedElements, block?.uuid)

  return useMemo(() => {
    const defItems = filterElementsByBlockMode({
      mode: block?.mode,
      elements: usedElements,
      element,
    }).map((group) => ({
      ...group,
      items: group.items.filter((item) => item.type !== 'layoutList'),
    }))

    const groups: IPickerGroup[] = []
    return lodash.sortBy(filterElems(groups, defItems, search), (elem) =>
      sortedGroups.indexOf(elem.type),
    )
  }, [block?.mode, search, element, usedElements])
}
